import LastViewedProductDetailService from '../../services/LastViewedProductDetailService';
import lastViewedProductDetailUseCase from './lastViewedProductDetailUseCase';

const lastViewedProductDetail = lastViewedProductDetailUseCase({
  LastViewedProductDetailService: LastViewedProductDetailService(),
});

export default lastViewedProductDetail;
